import React from 'react';
import PropTypes from 'prop-types';
import { AuthContext } from 'store/context';
import { AuthReducer } from 'store/reducers/AuthReducer';
import useReducerWithLogger from './Logger';

function AuthProvider({ children }) {
  const initData = {
    loading: false,
    message: '',
    error: '',
    token: JSON.parse(localStorage.getItem('token')),
    initURL: '',
    authUser: JSON.parse(localStorage.getItem('user')),
    sub: {},
  };

  const [AuthState, AuthDispatch] = useReducerWithLogger(AuthReducer, initData);

  return (
    <AuthContext.Provider
      value={{
        AuthState,
        AuthDispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
